import { useEntertainerEngagementContext } from '@contexts/EntertainerEngagementContext';

import { useSeriesByTagSlug } from '@queries/TagQueries';

import { createScreenComponent } from '@utilities/createScreenComponent';

import { Screen } from '@components/layout/Screen';
import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

import { ShowsTabContent } from '@screens/CommunityScreen/CommunityScreen';

interface SeriesEventsScreenProps {
  tagSlug: string;
}

export const SeriesShowsScreen = createScreenComponent<SeriesEventsScreenProps>(
  ({ tagSlug, back }) => {
    const { isFetched: seriesIsReady, series, seriesHost } = useSeriesByTagSlug(tagSlug);

    const { openGatedAddShowPopup } = useEntertainerEngagementContext();

    const handleAddEvent = () => {
      openGatedAddShowPopup({ cityId: series.city._id });
    };

    return (
      <Screen
        name="Series Events Screen"
        hideToolbar
        disableLocationPermissionGate
        headerProps={{
          back: { to: back ?? '/home' },
          title: <Screen.GagglTitle />,
        }}
      >
        <Screen.Content maxWidth={425}>
          {seriesIsReady && (
            <>
              <TitleToolbar text={`${series.city.name} Shows`} size="md" />
              <ShowsTabContent
                cityId={series.city._id}
                tagIds={[series._id]}
                onAddEvent={handleAddEvent}
                back={`/noauth/series/${tagSlug}/shows`}
              />
            </>
          )}
        </Screen.Content>
      </Screen>
    );
  },
);
